<template>
  <Dialog
    class="custom-dialog"
    :header="dialog.header"
    v-model:visible="dialog.show"
    :closeOnEscape="true"
    :dismissableMask="true"
    :modal="dialog.modal"
    :showHeader="false"
  >
    <IziGrid>
      <IziCol class="dialog-header">
        <IziButton
          label="X"
          theme="text"
          buttonType="primary"
          @click="close()"
        />
      </IziCol>
      <IziCol>
        <component :is="dialog.name" />
      </IziCol>
    </IziGrid>
  </Dialog>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import LayoutService from "../../../services/layout.service";
import { CustomDialog } from "../../../model/CustomDialog.model";
export default class IziDialog extends Vue {
  dialog: CustomDialog = {
    show: false,
    name: "",
    header: "",
    modal: false
  };
  created() {
    LayoutService.getDialog.subscribe((result: CustomDialog) => {
      this.dialog = { ...result };
    });
  }
  close() {
    this.dialog.show = false;
  }
}
</script>

<style lang="scss">
.p-dialog-mask {
  .custom-dialog {
    .dialog-header {
      text-align: right;
      .p-button {
        width: 5px;
        .p-button-label {
          color: #3a0000;
        }
      }
    }
  }
}
</style>
